import { Outlet, useLocation } from "react-router-dom";
import navigationRoutes from "@/utils/navigationRoutes";
import { Toaster } from "@/projects/Civi_Circle_Admin/components/ui/toaster";

const StarterLayout = () => {
  const location = useLocation();
  const isAdminLoginPage =
    location.pathname === navigationRoutes.ADMIN_LOGIN_PAGE;

  if (isAdminLoginPage) {
    return (
      <>
        <Toaster />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <Toaster />
      <div className="flex h-screen flex-col items-center justify-center from-blue-50 to-blue-100">
        <Outlet />
      </div>
    </>
  );
};

export default StarterLayout;
